import { logger } from 'affiny-core/logger';
import { authActions } from 'affiny-core/modules/auth/actions';
import { DangerousStore } from 'affiny-core/modules/dangerousStore';
import { selectAccessToken } from 'affiny-core/redux/selectors/authSelectors';
import { selectIovationBlackbox } from 'affiny-core/redux/selectors/configSelectors';
import { storageService } from 'affiny-core/services/storage/storage';
import merge from 'lodash/merge';
import { FetchLike, Middleware } from 'wretch/dist/middleware';
import { WretcherOptions } from 'wretch/dist/wretcher';
import { AuthResource } from '../resources/auth.resource';
import {
  COULD_NOT_REFRESH_TOKEN,
  isUnauthorized,
  NO_REFRESH_TOKEN,
  NOT_LOGGED_IN,
} from './middlewaresHelpers';

const getNewOpts = (options: WretcherOptions, tokenValue: string) => {
  return merge(options, {
    headers: { Authorization: `Bearer ${tokenValue}` },
  });
};

const getNewToken = async () => {
  const store = DangerousStore.store;

  const refreshToken = await storageService.getRefreshToken();

  if (!refreshToken) {
    throw new Error(NO_REFRESH_TOKEN);
  }

  const blackbox = selectIovationBlackbox(store.getState());

  const sessionOrigin = storageService.getSessionOrigin();
  const newToken = await AuthResource.refreshWithToken(
    refreshToken,
    sessionOrigin,
    blackbox
  );

  if (newToken.access_token) {
    store.dispatch(authActions.loginSuccess(newToken));

    return newToken.access_token;
  }

  throw new Error(COULD_NOT_REFRESH_TOKEN);
};

const getToken = async () => {
  const store = DangerousStore.store;
  const token = selectAccessToken(store.getState());

  // the case where token is undefined is handled by the refreshPeriodicallySaga
  // We still add this check in case authMiddleWare is called before refreshPeriodically
  if (!token) {
    console.warn(NOT_LOGGED_IN, DangerousStore.store.getState());
    // @TODO do not throw error which creates a new entry in Sentry
    throw new Error(NOT_LOGGED_IN);
  }

  return token;
};

export const authMiddleware: Middleware = () => {
  return (next: FetchLike) => async (url: string, options: WretcherOptions) => {
    let accessToken;
    let newOptions;
    const store = DangerousStore.store;

    try {
      accessToken = await getToken();
      newOptions = getNewOpts(options, accessToken);
    } catch (e) {
      logger.log(e);

      return store.dispatch(authActions.logout());
    }

    let response = await next(url, newOptions);

    if (isUnauthorized(response)) {
      // @TODO 05/13/2019 thibautgu@bam.tech: do not make this call if another call to getNewToken isPending
      accessToken = await getNewToken();
      newOptions = getNewOpts(options, accessToken);
      response = await next(url, newOptions);
    }

    if (isUnauthorized(response)) {
      store.dispatch(authActions.logout());
    }

    return response;
  };
};
